import { Controller } from '@hotwired/stimulus'

export default class TabsController extends Controller {
  static targets = ['tab', 'tabContent'];

  connect () {
    const currentTab = new URLSearchParams(window.location.search).get('current_tab')

    if (currentTab === null) {
      if (this.hasTabTarget && this.tabTargets.length > 0 && this.tabTargets[0]) {
        this.activateTab(this.tabTargets[0])
      }
    } else {
      const matchingTab = this.tabTargets.find(tab => tab && tab.dataset && tab.dataset.pathName === currentTab)
      if (matchingTab) {
        this.activateTab(matchingTab)
      }
    }
  }

  changeTab (event) {
    const tabId = event.target.dataset.tab
    const selectedTab = this.tabTargets.find(tab => tab.dataset.tab === tabId)
    this.updateUrlParams(selectedTab.dataset.pathName)
    this.activateTab(selectedTab)
  }

  activateTab (tab) {
    if (!tab || !tab.dataset || !tab.dataset.tab) {
      return
    }

    const tabContentId = tab.dataset.tab

    if (this.hasTabContentTarget) {
      this.tabContentTargets.forEach(tabContent => {
        if (tabContent) {
          tabContent.classList.add('hidden')
        }
      })
    }

    const tabContent = document.getElementById(tabContentId)
    if (tabContent) {
      tabContent.classList.remove('hidden')
    }

    if (this.hasTabTarget) {
      this.tabTargets.forEach(btn => {
        if (btn) {
          btn.classList.remove('active')
        }
      })
    }

    if (tab.classList) {
      tab.classList.add('active')
    }
  }

  updateUrlParams (currentTabName) {
    const urlSearchParams = new URLSearchParams(window.location.search)
    urlSearchParams.set('current_tab', currentTabName)
    window.history.replaceState({}, '', `${window.location.pathname}?${urlSearchParams}`)
  }
}
